import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

// Logo desktop (SVG)
import logoImage from '../assets/Ledger-logo.svg';
// Logo mobile (PNG)
import mobileLogo from '../assets/ledger-logo.png';
// Icône panier
import Carticon from '../assets/cart-icon.png';

const Navbar = () => {
  const [dropdown, setDropdown] = useState({
    products: false,
    appServices: false,
    learn: false,
    business: false,
  });

  const [mobileOpen, setMobileOpen] = useState(false);

  // Ferme tous les dropdowns
  const closeAllDropdowns = () => {
    setDropdown({
      products: false,
      appServices: false,
      learn: false,
      business: false,
    });
  };

  useEffect(() => { closeAllDropdowns(); }, [mobileOpen]);
  useEffect(() => {
    if (mobileOpen) document.body.classList.add('mobile-menu-open');
    else document.body.classList.remove('mobile-menu-open');
    return () => document.body.classList.remove('mobile-menu-open');
  }, [mobileOpen]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.width = '100vw';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollY) window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [mobileOpen]);

  // Pour rendre malléable : 3 sections distinctes
  return (
    <>
      {/* Overlay grisé */}
      <div className={`mobile-overlay ${mobileOpen ? 'opened' : ''}`} onClick={() => setMobileOpen(false)} />

      <nav className="navbar">
        <div className="navbar-container">
          {/* --- SECTION LOGO --- */}
          <div className="navbar-section navbar-logo">
            <Link to="/">
              <img src={logoImage} alt="Accueil" className="desktop-logo" />
              <img src={mobileLogo} alt="Accueil" className={`mobile-logo${mobileOpen ? ' logo-centered' : ''}`} />
            </Link>
          </div>

          {/* --- SECTION BURGER --- */}
          <div className={`burger-icon ${mobileOpen ? 'change' : ''}`} onClick={() => setMobileOpen(!mobileOpen)}>
            <div className="bar1" />
            <div className="bar2" />
            <div className="bar3" />
          </div>

          {/* --- SECTION LINKS --- */}
          <ul className={`navbar-section navbar-links ${mobileOpen ? 'links-open' : ''}`}>
            <li>
              <Link to="/activation" onClick={() => setMobileOpen(false)}>Activation</Link>
            </li>
            {/* Dropdowns (identiques à avant) */}
            <li className="dropdown"
                onMouseEnter={() => !mobileOpen && setDropdown(d => ({...d, products:true}))}
                onMouseLeave={() => !mobileOpen && setDropdown(d => ({...d, products:false}))}>
              <div className="dropdown-wrapper"
                  onClick={() => mobileOpen && setDropdown(d => ({...d, products:!d.products}))}>
                <span className={`dropdown-link ${dropdown.products ? 'active' : ''}`}>
                  Produits
                  <span className="dropdown-triangle"></span>
                </span>
              </div>
              {dropdown.products && (
                <ul className="dropdown-menu">
                  <li><a href="https://shop.ledger.com/fr/pages/ledger-flex">Ledger Flex</a></li>
                  <li><a href="https://shop.ledger.com/fr/pages/ledger-stax">Ledger Stax</a></li>
                  <li><a href="https://shop.ledger.com/fr/pages/ledger-nano-x">Ledger Nano X</a></li>
                  <li><a href="https://shop.ledger.com/fr/pages/ledger-nano-s-plus">Ledger Nano S Plus</a></li>
                  <li><a href="https://shop.ledger.com/fr/pages/hardware-wallets-comparison">Comparer nos appareils</a></li>
                  <li><a href="https://shop.ledger.com/fr/pages/hardware-wallet">Hardware Wallet</a></li>
                  <li><a href="https://shop.ledger.com/fr#category-bundle">Packs</a></li>
                  <li><a href="https://shop.ledger.com/fr#category-accessories">Accessoires</a></li>
                </ul>
              )}
            </li>
            {/* ... répète le même schéma pour les autres dropdowns */}
            <li className="dropdown"
                onMouseEnter={() => !mobileOpen && setDropdown(d => ({...d, appServices:true}))}
                onMouseLeave={() => !mobileOpen && setDropdown(d => ({...d, appServices:false}))}>
              <div className="dropdown-wrapper"
                  onClick={() => mobileOpen && setDropdown(d => ({...d, appServices:!d.appServices}))}>
                <span className={`dropdown-link ${dropdown.appServices ? 'active' : ''}`}>
                  App & Services
                  <span className="dropdown-triangle"></span>
                </span>
              </div>
              {dropdown.appServices && (
                <ul className="dropdown-menu">
                  <li><a href="https://www.ledger.com/fr/ledger-live">Ledger Live</a></li>
                  <li><a href="https://greenyellow-lapwing-agb6npjn44c3o9wn.builder-preview.com/activation">Ledger Recover</a></li>
                  <li><a href="https://www.ledger.com/fr/cl-card">Carte CL</a></li>
                  <li><a href="https://www.ledger.com/fr/supported-services">Service pris en charge</a></li>
                  <li><a href="https://www.ledger.com/fr/coin/price">Prix des cryptos</a></li>
                </ul>
              )}
            </li>
            <li className="dropdown"
                onMouseEnter={() => !mobileOpen && setDropdown(d => ({...d, learn:true}))}
                onMouseLeave={() => !mobileOpen && setDropdown(d => ({...d, learn:false}))}>
              <div className="dropdown-wrapper"
                  onClick={() => mobileOpen && setDropdown(d => ({...d, learn:!d.learn}))}>
                <span className={`dropdown-link ${dropdown.learn ? 'active' : ''}`}>
                  Apprendre
                  <span className="dropdown-triangle"></span>
                </span>
              </div>
              {dropdown.learn && (
                <ul className="dropdown-menu">
                  <li><a href="https://www.ledger.com/fr/academy">Ledger Academy</a></li>
                  <li><a href="https://quest.ledger.com/">Learn & Earn</a></li>
                  <li><a href="https://www.ledger.com/fr/academy/quest-ce-que-le-web-30nbsp-tout-ce-quil-faut-savoirnbsp">L'essentiel</a></li>
                  <li><a href="https://www.ledger.com/fr/blog">Blog</a></li>
                  <li><a href="https://www.ledger.com/fr/buy">Comment acheter</a></li>
                  <li><a href="https://www.ledger.com/fr/swap">Comment échanger</a></li>
                  <li><a href="https://www.ledger.com/fr/staking">Comment staker</a></li>
                </ul>
              )}
            </li>
            <li className="dropdown"
                onMouseEnter={() => !mobileOpen && setDropdown(d => ({...d, business:true}))}
                onMouseLeave={() => !mobileOpen && setDropdown(d => ({...d, business:false}))}>
              <div className="dropdown-wrapper"
                  onClick={() => mobileOpen && setDropdown(d => ({...d, business:!d.business}))}>
                <span className={`dropdown-link ${dropdown.business ? 'active' : ''}`}>
                  Pour les entreprises
                  <span className="dropdown-triangle"></span>
                </span>
              </div>
              {dropdown.business && (
                <ul className="dropdown-menu">
                  <li><a href="https://enterprise.ledger.com/?utm_source=mainsite&utm_medium=header">Enterprise Solutions</a></li>
                  <li><a href="https://www.ledger.com/fr/partners">Partenaires Ledger</a></li>
                  <li><a href="https://co-branded.ledger.com/">Co-branding</a></li>
                </ul>
              )}
            </li>
            <li>
              <Link to="/" onClick={() => setMobileOpen(false)}>Assistance</Link>
            </li>
          </ul>

          {/* --- SECTION PANIER --- */}
          <div className="navbar-section navbar-cart">
            <Link to="/">
              <img src={Carticon} alt="Accueil" className="home-image" />
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
